import { render, staticRenderFns } from "./VChangableLabel.vue?vue&type=template&id=53f2e26f&scoped=true&functional=true"
import script from "./VChangableLabel.vue?vue&type=script&lang=js"
export * from "./VChangableLabel.vue?vue&type=script&lang=js"
import style0 from "./VChangableLabel.vue?vue&type=style&index=0&id=53f2e26f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "53f2e26f",
  null
  
)

export default component.exports